import React, { useEffect, useState } from 'react';

import { Background, Button, Item, Modal, Wrapper } from './styles';

export interface ListItem {
  title: string;
  isDelete?: boolean;
  clickHandler: () => void;
  disabled?: boolean;
}

export interface Props {
  items: ListItem[];
}

const MoreButton = ({ items }: Props) => {
  const [modalDisplaying, setModalDisplaying] = useState(false);

  useEffect(() => {
    setModalDisplaying(false);
  }, [items]);

  return (
    <div>
      <Background onClick={() => setModalDisplaying(false)} isModalOpened={modalDisplaying} />
      <Wrapper isActive={modalDisplaying} onClick={() => setModalDisplaying(true)}>
        <Button />
        {modalDisplaying && (
          <Modal>
            {items.map(({ title, isDelete, clickHandler, disabled }) => (
              <Item
                key={title}
                onClick={() => {
                  if (disabled) {
                    return;
                  }
                  clickHandler();
                  setModalDisplaying(false);
                }}
                disabled={disabled}
                isDelete={isDelete || false}>
                {title}
              </Item>
            ))}
          </Modal>
        )}
      </Wrapper>
    </div>
  );
};

export default MoreButton;
